/*
  * BalanceText https://github.com/adobe/balance-text
  * Adds line-breaks to balance text nicely in multiple lines, like in proposed css property text-wrap:balance.
  * Once/if native property is implemented, the this polyfill can be deprecated
*/
class BalanceText {
  /* Constructor
   * @param {string} selectors - DOM selector list
  */
  constructor(selectors = false) {
    const defaults = 'h1:not(.no-text-balance), h2:not(.no-text-balance), h3:not(.no-text-balance)';
    const elements = selectors || defaults
    this.selectors = document.querySelectorAll(elements)
  }

  /*
   * Init
  */
  init() {
    if (this.selectors.length > 0) {
      import('../vendor/balancetext.js').then( ({default: balancedText}) => {
        balancedText(this.selectors, {watch: true})
      })
    }
  }
}

export default BalanceText
